<template>
	<div>
		<div class="text-center absolute">
			<loading :active.sync="isUploading" :is-full-page="fullPage" :background-color="colorOverlay" :color="colorLoading">
				<template slot="before">
					<div class="absolute text-lg loading-logo">
						<img src="/img/icon-512.png" class="d-inline-block align-top icon-loading-comp" alt="Grafias">
					</div>
				</template>
				<template slot="after">
					<div>
						<div class="text-lg loading-text mb-2">{{ $t('Uploading') }} {{ uploadProgress }}%</div>
						<div class="mt-2">
							<button class="btn btn-cancel " @click="onCancel">Cancel</button>
						</div>
					</div>
				</template>
			</loading>
		</div>
		<div>
			<label>{{$t('Select background for your composition you can')}}</label>
			<label class="text-primary ml-1 mr-1 pointer" @click="isUploadModal = true">{{$t('upload')}}
				<input
					id="mediaInputBg"
					type="file"
					class="hidden"
					accept=".png,.gif,.jpeg,.jpg"
					@change="onFileSelected"
				/>
			</label>
			<label>{{$t('upload your image or select from')}}</label>
			<label class="text-primary ml-1 mr-1 pointer" @click="isGalleryVisible = true">{{$t('Gallery')}}</label>
		</div>
		<div class="d-flex flex-row">
			<!-- <button class="btn-icon btn btn-arrow pr-1" @click="moveAndFocus(0)"> <i class="material-icons ">keyboard_arrow_left</i></button> -->
			<div ref="imageScroll" class="scroll-area scrolls" id="scrolls-style">
				<div class="background-flex">
					<div :id="background.id" class="bg-list pr-1" v-for="(background, index) in backgrounds" :key="index"
						@click="setSelectedBackground(background)">
						<div class="image-background-item" :class="selectedBackgroundClass(background)">
							<img  class="imgBg" ref="bgImage" :src="background.path" height="90" width="177" />
						</div>
					</div>
				</div>
			</div>
			<!-- <button class="btn-icon btn btn-arrow pl-1" @click="moveAndFocus(1)"> <i class="material-icons ">keyboard_arrow_right</i></button> -->
		</div>
			<!-- <button class="btn btn-primary btn-sm mt-2" @click="upload()"> Upload</button> -->
			<gallery-popup
				@select="selectImageFromGallery"
				@close="isGalleryVisible = false"
				v-if="isGalleryVisible"
			/>
	</div>
</template>


<script>
import { mapGetters } from 'vuex';
import Loading from 'vue-loading-overlay';
import GalleryPopup from '@/components/GalleryPopup.vue';
import {
	getAxiosErrorMessage,
	duplicateVar,
} from '@/lib/helper';
import mediasApi from '@/api/medias';
import fileApi from '@/api/file';
import categoriesApi from '@/api/categories';


export default {
	name: 'compositionBackground',
	components: {
		GalleryPopup,
		Loading,
	},
	data() {
		return {
			isGalleryVisible: false,
			isUpload: false,
			valueVideo: '',
			audioOptions: [],
			videoOptions: [],
			programOptions: [],
			detailsDebug: '',
			activeBtn: '',
			backgrounds: [
			],
			imgIndex: 0,
			selectedBackground: null,
			isDeleteEnable: false,
			// media upload
			isFetching: false,
			isUploading: false,
			uploadProgress: 0,
			mediaUrl: '',
			mediaFile: null,
			mediaLabel: '',
			categoryMedia: '',
			isUploadModal: false,
			isAdding: false,
			// categories
			categories: [],
			isSelectedCategory: false,
			categoryId: '',
			isFetchingMedia: false,
			uploadLimit: '',
			isEnableUploadLimit: false,
			settings: null,
			fileSize: '',
			userClient: {},
			// storage warn
			isStorage99Percent: false,
			isStorage80Percent: false,
			currentStorage: false,
			availableStorage: false,
			// loading
			fullPage: true,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
			cancelUpload: null,
		};
	},
	methods: {
		selectImageFromGallery(item) {
			this.$emit('selectBackground', item.path);
			this.isGalleryVisible = false;
		},
		moveAndFocus(isRight) {
			// const imgId = 0;
			if (isRight) {
				if (this.imgIndex <= this.backgrounds.length) {
					this.imgIndex++;
					document.getElementById(`bg${this.imgIndex}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
					this.selectAndFocus(this.imgIndex);
				} else {
					this.imgIndex = 1;
					document.getElementById(`bg${this.imgIndex}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
					this.selectAndFocus(this.imgIndex);
				}
			} else {
				// eslint-disable-next-line no-lonely-if
				if (this.imgIndex >= 1) {
					this.imgIndex--;
					document.getElementById(`bg${this.imgIndex}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
					this.selectAndFocus(this.imgIndex);
				} else {
					this.imgIndex = 10;
					document.getElementById(`bg${this.imgIndex}`).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
					this.selectAndFocus(this.imgIndex);
				}
			}
		},
		selectAndFocus(id) {
			// eslint-disable-next-line eqeqeq
			const selectedBackground = this.backgrounds.find(bg => bg.id == `bg${id}`);
			this.setSelectedBackground(selectedBackground);
		},
		setSelectedBackground(background) {
			this.selectedBackground = background;
			this.$emit('selectBackground', background.path);
		},
		selectedBackgroundClass(background) {
			return this.selectedBackground === background ? 'active' : '';
		},
		setDefaultBackground() {
			if (this.backgrounds.length > 0) this.setSelectedBackground(this.backgrounds[0]);
		},
		setActiveBackground() {
			this.$emit('setBackgroundConfig', this.selectedBackground.path);
		},
		getMedias() {
			const params = {
				page: 1,
				limit: 100,
				order_by: 'created_at',
				sort_by: 'asc',
				type: 'image',
				category_id: 2,
			};
			this.backgrounds = [
				{ id: 'bg1', type: 'local', path: '/img/backgrounds/bg1.jpg' },
				{ id: 'bg2', type: 'local', path: '/img/backgrounds/bg2.jpg' },
				{ id: 'bg3', type: 'local', path: '/img/backgrounds/bg3.jpg' },
				{ id: 'bg4', type: 'local', path: '/img/backgrounds/bg4.jpg' },
				{ id: 'bg5', type: 'local', path: '/img/backgrounds/bg5.jpg' },
				{ id: 'bg6', type: 'local', path: '/img/backgrounds/bg6.jpg' },
				{ id: 'bg7', type: 'local', path: '/img/backgrounds/bg7.jpg' },
				{ id: 'bg8', type: 'local', path: '/img/backgrounds/bg8.jpg' },
				{ id: 'bg9', type: 'local', path: '/img/backgrounds/bg9.jpg' },
				{ id: 'bg10', type: 'local', path: '/img/backgrounds/bg10.jpg' },
			];
			const callback = (response) => {
				for (let index = 0; index < response.data.length; index++) {
					const image = response.data[index];
					this.backgrounds.push(image);
				}
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Gallery Media',
					text: message,
				});
			};
			mediasApi.getList(params, callback, errorCallback);
		},
		onFileSelected(e) {
			this.initDataUser();
			this.availableStorage = 0;
			this.currentStorage = 0;
			// get data max upload
			const oneMB = 1048576; // MB
			if (!this.isEnableUploadLimit) {
				this.uploadLimit = 1048; // one gb
			}
			// upload
			let files = e.target.files;
			const fileSizeInMb = files[0].size / oneMB;
			const oneGB = 1048;
			if (files.length > 0) {
				// checking file type
				if (files[0].type === 'image/jpeg' || files[0].type === 'image/gif' || files[0].type === 'image/png' || files[0].type === 'image/jpg') {
					if (fileSizeInMb <= oneGB) {
						if (fileSizeInMb <= this.uploadLimit) {
							if (this.userStorage && !this.isSuperAdmin) {
								const isRemainingStorageAvailable = this.userStorage.total_remaining >= 0 && this.userStorage.total_remaining >= (files[0].size / oneMB);
								const nomalizedTotalRemaining = this.userStorage.total_remaining <= 0 ? 0 : this.userStorage.total_remaining;
								if (!isRemainingStorageAvailable) {
									const message = `Your total used Storage is ${this.userStorage.total_usage} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									files = null;
									this.isCached = false;
									this.isCaching = false;
									if (document.querySelector('#mediaInputBg')) document.querySelector('#mediaInputBg').value = '';
									return;
								}
							// eslint-disable-next-line no-else-return
							}
							if (!this.backgrounds.some(data => data.name === files[0].name) && !this.backgrounds.some(data => data.size === files[0].size)) {
								const file = files[0];
								if (!file) {
									this.$notify({
										group: 'app',
										type: 'warn',
										title: 'Upload Media',
										text: 'Sorry, currently we cant upload the file',
									});
									return;
								}

								this.isUploading = true;
								this.fileSize = file.size / oneMB;
								this.mediaFile = file;
								// Remove extension from filename to set label
								const filename = duplicateVar(file.name);
								this.mediaLabel = duplicateVar(filename);

								const params = new FormData();
								params.append('file', file);
								if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
								const callback = (response) => {
									const mediaUrl = response.data;
									this.mediaUrl = mediaUrl;
									this.showUploadModal = false;
									this.uploadProgress = 0;
									this.addMedia();
									document.querySelector('#mediaInputBg').value = '';
									if (this.userStorage) {
										// on the spot 100%
										// eslint-disable-next-line
										const isStorageOnTheSpot100 = this.userStorage.total_remaining == this.fileSize;
										if (isStorageOnTheSpot100) {
											const message = 'Your total used Storage is 100%';
											this.$notify({
												group: 'app',
												type: 'warning',
												title: 'Upload Media',
												text: message,
											});
										}
										// right on 80% mark
										const resultPercentage80 = this.userStorage.total * 80 / 100;
										const fixTotalUsageAndFile80 = (this.userStorage.total_usage + this.fileSize).toFixed(4);
										// eslint-disable-next-line
										const isStorageOnTheSpot80 = fixTotalUsageAndFile80 >= resultPercentage80 && this.userStorage.total_usage < resultPercentage80;
										if (isStorageOnTheSpot80) {
											const message = 'Your total used Storage is over 80%';
											this.$notify({
												group: 'app',
												type: 'warning',
												title: 'Upload Media',
												text: message,
											});
											this.isStorage80Percent = true;
											this.currentStorage = this.userStorage.total - resultPercentage80;
											this.availableStorage = this.userStorage.total;
										}
										// right on 99% mark
										const resultPercentage99 = this.userStorage.total * 99 / 100;
										const fixTotalUsageAndFile99 = (this.userStorage.total_usage + this.fileSize).toFixed(4);
										// eslint-disable-next-line
										const isStorageOnTheSpot99 = fixTotalUsageAndFile99 >= resultPercentage99 && this.userStorage.total_usage < resultPercentage99;
										if (isStorageOnTheSpot99) {
											const message = 'Your total used Storage is over 99%';
											this.$notify({
												group: 'app',
												type: 'warning',
												title: 'Upload Media',
												text: message,
											});
											this.isStorage99Percent = true;
											this.currentStorage = this.userStorage.total - resultPercentage99;
											this.availableStorage = this.userStorage.total;
										}
									}
								};
								const errorCallback = (e) => {
									const message = getAxiosErrorMessage(e);
									this.$notify({
										group: 'app',
										type: 'error',
										title: 'Upload Media',
										text: message,
									});
									this.isUploading = false;
								};
								const progressCallback = (progress) => {
									this.uploadProgress = progress;
								};
								const cancelUploadCallback = (c) => {
									this.cancelUpload = c;
								};
								fileApi.upload(params, callback, errorCallback, progressCallback, cancelUploadCallback);
							} else {
								this.$notify({
									group: 'app',
									type: 'error',
									text: 'File already exist, please upload another file',
								});
								files = null;
								document.querySelector('#mediaInputBg').value = '';
							}
						} else {
							files = null;
							document.querySelector('#mediaInputBg').value = '';
							const appUrl = process.env.VUE_APP_URL;
							this.$notify({
								group: 'app',
								type: 'error',
								text: `You current package upload limit is ${this.uploadLimit} MB, <a href="${appUrl}/settings?menu=subscribe"> Upgrade your subscription </a>`,
							});
						}
					} else {
						files = null;
						document.querySelector('#mediaInputBg').value = '';
						// const appUrl = process.env.VUE_APP_URL;
						this.$notify({
							group: 'app',
							type: 'error',
							text: 'Max upload limit is 1GB',
						});
					}
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		addMedia() {
			this.isAdding = true;
			const params = {
				name: this.mediaLabel,
				path: this.mediaUrl,
				type: 'image',
				category_id: 2,
				size: this.fileSize,
			};
			if (this.activeRouteName === 'RundownEditor') {
				params.rundown_id = this.rundown.id || null;
			}
			const callback = (response) => {
				const item = response.data;
				this.backgrounds.push(item);
				this.isUploading = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Media',
					text: response.message,
				});
				setTimeout(() => {
					this.scrollLeft();
				}, 500);
				this.isAdding = false;
				this.isUploadModal = false;
				if (this.isStorage80Percent || this.isStorage99Percent) this.notifyEmailStorage();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
				this.isAdding = false;
				this.availableStorage = 0;
				this.currentStorage = 0;
			};
			mediasApi.create(params, callback, errorCallback);
		},
		scrollLeft() {
			const contentBg = document.querySelector('.scroll-area');
			contentBg.scrollLeft += 99999999999999999999999999;
		},
		notifyEmailStorage() {
			const callback = () => {
				this.availableStorage = 0;
				this.currentStorage = 0;
				this.isStorage99Percent = false;
				this.isStorage80Percent = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
			};
			const params = {
				current_storage: this.currentStorage,
				available_storage: this.availableStorage,
			};
			mediasApi.notifyEmail(params, callback, errorCallback);
		},
		fetchCategories() {
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'name',
				sort_by: 'asc',
				type: 'media',
				category_id: 2,
			};
			const callback = (response) => {
				const categories = response.data.data;
				this.categories = categories;
			};
			const errorCallback = () => {};
			categoriesApi.getList(params, callback, errorCallback);
		},
		selectedCategory(category) {
			this.isSelectedCategory = true;
			this.categoryId = category.id;
			this.fetch(true);
		},
		initDataUser() {
			if (this.user) {
				const settingsString = this.user && this.user.settings ? this.user.settings : '';
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				// const roles = this.user && this.user.roles ? this.user.roles : [];
				const isSuperAdmin = this.isSuperAdmin || null;// check the computed import the getters befor implement
				const isCollaborator = this.isCollaborator || null;// check the computed import the getters befor implement
				const isClient = this.isClient || null;// check the computed import the getters befor implement
				if (!isSuperAdmin && isClient) { // not admin and can be collaborator and client who have two roles
					this.isEnableUploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.is_enabled ? duplicateVar(settings.subscription.storage.is_enabled) : false;
					this.uploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.upload_size ? duplicateVar(settings.subscription.storage.upload_size) : 10;
				} else if ((!isSuperAdmin && isCollaborator && !isClient)) { // only for collaborator that invited by client
					if (this.localClientUser) {
						const userClientSettingsString = this.localClientUser && this.localClientUser.settings ? this.localClientUser.settings : '';
						const userClientSettings = JSON.parse(userClientSettingsString);
						this.isEnableUploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.is_enabled ? duplicateVar(userClientSettings.subscription.storage.is_enabled) : false;
						this.uploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.upload_size ? duplicateVar(userClientSettings.subscription.storage.upload_size) : 10;
					}
				} else { // for superadmin only
					this.isEnableUploadLimit = false;
					this.uploadLimit = 1048;
				}
			}
		},
		onCancel() {
			if (this.cancelUpload) {
				this.cancelUpload();
				this.mediaFile = null;
				this.isCaching = false;
				this.isCached = false;
				this.isUploading = false;
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			clientUser: 'clientUser',
			isClient: 'isClient',
			isSuperAdmin: 'isSuperAdmin',
			isCollaborator: 'isCollaborator',
		}),
		userStorage() {
			return {
				total: this.user && this.user.storage && this.user.storage.total ? this.user.storage.total : 0,
				total_remaining: this.user && this.user.storage && this.user.storage.total_remaining ? this.user.storage.total_remaining : 0,
				total_usage: this.user && this.user.storage && this.user.storage.total_usage ? this.user.storage.total_usage : 0,
			};
		},
	},
	created() {
		this.getMedias();
		this.fetchCategories();
		if (this.clientUser) {
			this.localClientUser = this.clientUser;
		}
	},
};

</script>

<style scoped>
img {
	height: 90px;
}
.icon-loading-comp {
	width: 20px!important;
	height: 20px!important;
}
</style>
